import { Nav } from "@/components/nav/Nav";
import { AppSidebar } from "@/components/sidebar/AppSidebar";
import {
  SidebarInset,
  SidebarProvider,
  SidebarTrigger,
} from "@/components/ui/sidebar";
import clsx from "clsx";
import { Outlet, useLocation } from "react-router-dom";

export function AppShellLayout() {
  const { pathname } = useLocation();
  const isMapRoute = pathname.includes("map");

  return (
    <SidebarProvider>
      <div className="flex h-dvh w-full overflow-hidden">
        <AppSidebar />
        <SidebarInset className="flex min-w-0 flex-1 flex-col min-h-0 overflow-hidden">
          <header className="sticky top-0 z-10 border-b bg-background/80 backdrop-blur shrink-0">
            <div className="flex items-center gap-2 p-3 md:p-4">
              <SidebarTrigger />
              <div className="min-w-0 flex-1 flex justify-center">
                <Nav />
              </div>
            </div>
          </header>

          <div
            className={clsx(
              "flex min-h-0 min-w-0 flex-1 overscroll-contain justify-center",
              !isMapRoute && "pb-[var(--safe-bottom)]",
            )}
          >
            <Outlet />
          </div>
        </SidebarInset>
      </div>
    </SidebarProvider>
  );
}
